module.exports = __webpack_public_path__ + "img/easter_egg_modal_cover_found.0f4012cd.png";